// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"f6f00abe901f813ebda1","293":"f0603b6d56f3cf5ad42c"}[chunkId] + ".js";
};